<template>
  <v-card>
    <div class="pa-3 d-flex flex-column" style="max-height: 80vh; overflow: hidden">
      <div class="text-h4">Züri 9 Fahrdienst Statistik</div>

      <div class="d-flex flex-column flex-nowrap">
        <div class="text-h6">{{firstOfMonth}} - {{ calculationDate }}</div>
        <div class="text-h6" v-html="fahrdienstStats.htmlFahrstundenAtCalculatedDate"></div>
        <div class="text-h6" v-html="fahrdienstStats.htmlDeltaMonthToDate"></div>
      </div>
      <div class="d-flex scroll-container" style="flex: 1">
        <div>
          <v-simple-table class="mx-auto d-flex">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Datum</th>
                  <th class="text-right">Fahrdienststunden</th>
                  <th class="text-right">Tagessoll (Richtwert)</th>
                  <th class="text-right">Abweichung</th>
                  <th class="text-right">Abweichung aufsummiert</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in dayStats" :key="item.dayFormatted">
                  <td>{{ item.dayFormatted }}</td>
                  <td class="text-right">{{round(item.fahrdienstHoursPerDay || 0,2) }}</td>
                  <td class="text-right">{{ zueri9FahrstundenTagesRichtwert }}</td>
                  <td class="text-right">{{ - round(zueri9FahrstundenTagesRichtwert - item.fahrdienstHoursPerDay||zueri9FahrstundenTagesRichtwert,2)}}</td>
                  <td class="text-right">{{ - round(item.runningTotal,2) }}</td>
                </tr>
                <tr>
                  <td class="font-weight-bold">Total</td>
                  <td class="font-weight-bold text-right">{{ round(fahrdienstStats.monthTotal,2) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
    </div>

    <div class="pa-4 d-flex justify-end">
      <v-btn color="primary" text @click="$emit('close')"> Schliessen </v-btn>
    </div>
  </v-card>
</template>
<script>
import dateUtils from '@/common/dateUtils';
import utils, {round} from "@/common/utils";

export default {
  name: 'FahrdienstStats',
  props: {
    fahrdienstStats: Object,
    zueri9FahrstundenTagesRichtwert: Number,
  },

  computed: {
    calculationDate() {
      return dateUtils.formatAsLocaleShortDate(this.fahrdienstStats.calculatedForDate);
    },
    firstOfMonth() {
      let firstOfMonth = new Date(this.fahrdienstStats.calculatedForDate.getTime());
      firstOfMonth.setDate(1);
      return dateUtils.formatAsLocaleShortDate(firstOfMonth);
    },
    dayStats() {
      let now = new Date(this.fahrdienstStats.calculatedForDate.getTime());

      let dayStats =Object.keys(this.fahrdienstStats.runningTotals).sort((a,b)=>Number(a)>Number(b)?1:-1)
        .map((day) => {
          let fahrdienstHoursPerDay = this.fahrdienstStats.applicableHoursPerDayInCurrentMonth[day];
          now.setDate(day);
          let dayFormatted = dateUtils.formatAsLocaleShortDate(now);
          return { day, dayFormatted, fahrdienstHoursPerDay ,runningTotal:this.fahrdienstStats.runningTotals[day]};
        });
      return dayStats;
    },

  },
  methods: {
    round(value,places) {
      return utils.round(value,places)
    }
  },
};
</script>